export const modifyReducer = (state, updates) => {
  return { ...state, ...updates };
};
